<template>
  <div class="row profile-body profile-page-wrapper" v-if="userProfileData.membership.member_type_id === 3">
    <div v-if="isProfileloading || refreshLoading" class="d-flex justify-content-center userpf-loader">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="col-md-12">
      <div class="card table-head Merchandise">
        <div class="card-header">
          <div class="header-title">
            <h3>Family Members</h3>
          </div>
          <div class="m-0 float-sm-right">
            <b-button
                v-if="familyMemberCount <= 5"
                variant="outline-primary"
                class="btn float-right"
                v-b-modal.modal-family-member-add-option
                :disabled="addFamilyMemberLoading"
            >
              <i class="fa" :class="[addFamilyMemberLoading ? 'fa-circle-notch fa-spin' : 'fa-plus-circle']"></i> Add Member
            </b-button>
          </div>
        </div>
        <div class="card-body p-0 table-responsive">
          <b-tabs justified pills card>
            <b-tab v-for="(member, index) in userProfileData.families"
                   :key="'types'+index"
                   :active="currentMemberId === member.id">
              <template #title>
                <div class="tab-title">
                  <span class="title-txt">{{ member.personal_details.full_name+' ('+relationArr[member.personal_details.relation][0]+')' }}</span>
                  <b-button
                      v-b-tooltip.hover
                      title="Remove this member from the family"
                      :variant="currentMemberId === member.id ? 'danger' : 'outline-danger'"
                      class="btn btn-sm ml-auto remove-btn"
                      @click="detachMember(member)">
                    <span class="fa fa-times-circle"></span>
                  </b-button>
                </div>
              </template>
              <div class="row">
                <div class="col-md-6 r-pad">
                  <div class="card mb-3">
                    <div class="card-header container-fluid">
                      <div class="row">
                        <div class="col-md-5">
                          <h3>{{ props_fields.personal.tab_title || "Personal Information"}}</h3>
                        </div>
                        <div class="col-md-7 float-right">
                          <button v-if="currentMemberId === member.id"
                                  @click="resetForm()"
                                  v-b-modal.modal-center1
                                  class="btn btn-outline-primary btn-sm float-right ml-1">
                            <span class="fa fa-edit"></span>
                            Edit
                          </button>
                          <button v-else
                                  :class="{ 'actions-click': className }"
                                  class="btn btn-outline-primary btn-sm float-right ml-1 "
                                  @click="switchProfileView(member.id)">
                            <span class="fa fa-eye"></span> Profile
                          </button>
                          <button
                              class="btn btn-outline-primary btn-sm float-right"
                              @click="impersonate(member.confirmation_code)">
                            <span class="fa fa-user-secret"></span> Login as {{member.confirmation_code || "N/A"}}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6 col-lg-4" v-if="props_fields.personal && props_fields.personal.title">
                          <div class="form-group">
                            <label class="form-label">{{ props_fields.personal.title.label || 'Title'}}</label>
                            <span>{{member.personal_details.title || "N/A"}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4 ">
                          <div class="form-group">
                            <label class="form-label">First Name</label>
                            <span>{{member.personal_details.first_name || "N/A"}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">Middle Initial</label>
                            <span>{{member.personal_details.middle_name || ""}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">Last Name</label>
                            <span>{{member.personal_details.last_name || "N/A"}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">Birthday</label>
                            <span>{{member.personal_details.dob || "N/A"}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">Gender</label>
                            <span>{{member.personal_details.gender || "N/A"}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">Affiliated Clubs/Teams</label>
                            <span class="title">{{ member.affiliated_clubs_names || "N/A"}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">1st Choice</label>
                            <span class="title">{{ sportDisciplines[member.personal_details.first_choice] || "NP - No Preference" }}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">2nd Choice</label>
                            <span class="title">{{ sportDisciplines[member.personal_details.second_choice] || "NP - No Preference"}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">Federation </label>
                            <span>{{member.personal_details.home_federation || "N/A"}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">Skier License</label>
                            <span>{{member.personal_details.skier_license || "N/A"}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">Relationship</label>
                            <span>{{relationArr[member.personal_details.relation] || "N/A"}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card mb-3">
                    <div class="card-header ">
                      <div class="header-title">
                        <h3>Membership Information</h3>
                      </div>
                      <div class="modal-btn" v-if="currentMemberId === member.id">
                        <b-button v-b-modal.modalMembership><span class="fa fa-edit"></span> Edit</b-button>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="form-label">Membership #</label>
                            <span>{{member.confirmation_code || "N/A"}}</span>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="form-label">Start Date</label>
                            <span>{{ startDate }}</span>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="form-label">Expiration Date</label>
                            <span>
                              {{ userProfileData && userProfileData.membership && userProfileData.membership.period !== 999 ? validThru : "N/A"}}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <div class="d-flex">
                              <label class="form-label">
                                Membership Status
                                <span v-if="member.membership_status_info" v-b-tooltip.hover :title="member.membership_status_info">
                                  <img
                                      style="width:18px;"
                                      v-if="getSiteProps('profile.membershipStatusIcon')"
                                      v-bind:src="'/dist/img/memberregistration/tooltip-icon-small.png'"
                                      alt="tooltipicon" />
                                </span>
                              </label>
                              <span
                                  class="text-danger bordernote"
                                  v-if="member.note"
                                  v-b-tooltip.hover
                                  :title="member.note">
                                <i class="fas fa-clipboard"></i>
                              </span>
                            </div>
                            <span class="text-success" v-if="member.status_text === 'Current'">
                              <img class="mr-1" src="/dist/img/profile/ico-status-current.png" alt="Current">
                              {{ member.status_text }} (Expires {{member.valid_thru | formatDob }})
                            </span>
                            <span class="text-warning" v-else-if="member.status_text !== 'Expired'">
                              <img class="mr-1" src="/dist/img/profile/ico-status-pending.png" alt="Pending">
                              {{ member.status_text || 'N/A' }}
                            </span>
                            <span class="text-warning" v-else>
                              <img class="mr-1" src="/dist/img/profile/ico-status-pending.png" alt="Expired"> Expired
                            </span>
                          </div>
                        </div>
                        <div class="col-md-4" v-if="member.member_type_id !== 2">
                          <div class="form-group">
                            <label class="form-label">Waiver Status</label>
                            <span class="text-success" v-if="member.waiver_status === 1">
                              <img class="mr-1" src="/dist/img/profile/ico-status-current.png" alt="Signed">
                              Signed (Expires {{ userProfileData && userProfileData.membership && userProfileData.membership.period !== 999 ? validThru : "N/A" }})
                            </span>
                            <span class="text-warning" v-else>
                              <img class="mr-1" src="/dist/img/profile/ico-status-pending.png" alt="Not Signed"> Not signed
                            </span>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group" v-if="member.safe_sport_screening_compliance === true">
                            <label class="form-label">
                              Safe Sport Training Status
                              <a v-if="member.safe_sport != null" class="btn-refersh" @click.prevent="getSafeSportUserApi(member.confirmation_code, true);">
                                {{ safeSportRefreshButton }}
                              </a>
                            </label>
                            <span class="text-success" v-if="member.safe_sport != null && member.safe_sport.safe_sport_status_text === 'Complete'">
                              <img class="mr-1" src="/dist/img/profile/ico-status-current.png" alt="Complete">
                              {{ member.safe_sport.safe_sport_status_text}} (Expires {{ member.safe_sport.expiration }})
                            </span>
                            <span class="text-warning" v-else-if="member.safe_sport != null">
                              <img class="mr-1" src="/dist/img/profile/ico-status-pending.png" alt="Pending">
                              {{ member.safe_sport.safe_sport_status_text || "N/A"}}
                              <template v-if="member.safe_sport.safe_sport_status === 13 && member.safe_sport.expiration">
                                <br>(On {{ member.safe_sport.expiration }})
                              </template>
                            </span>
                            <span class="text-warning" v-else>Not Started</span>
                          </div>
                          <div class="form-group" v-else>
                            <label class="form-label">Safe Sport Training Status</label>
                            <span class="">N/A</span>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group"
                               v-if="member.safe_sport_screening_compliance === true ||
                               (member.membership.id === 5 && member.personal_details.relation !== 2 && age > 17) ||
                               (member.membership.id === 4 && age > 17)">
                            <label class="form-label">
                              Background Screen Status
                              <span
                                  v-if="member.background_screening_with_out_type != null && member.background_screening_with_out_type.background_screening_info"
                                  v-b-tooltip.hover
                                  :title="member.background_screening_with_out_type.background_screening_info">
                                <img
                                    v-bind:src="'/dist/img/memberregistration/tooltip-icon-small.png'"
                                    alt="tooltipicon" />
                              </span>
                            </label>
                            <span
                                class="text-success"
                                v-if="member.background_screening_with_out_type != null &&
                                member.background_screening_with_out_type.status === 2">
                              <img
                                  class="mr-1"
                                  src="/dist/img/profile/ico-status-current.png" alt="Clear">
                                {{ member.background_screening_with_out_type.background_screening_status_text || "N/A" }}
                                (Expires {{ member.background_screening_with_out_type.expiration | formatDob }})
                            </span>
                            <span
                                class="text-danger"
                                v-else-if="(member.background_screening_with_out_type != null &&
                                member.background_screening_with_out_type.status === 7) &&
                                (member.background_screening_with_out_type != null &&
                                member.background_screening_with_out_type.status === 3)">
                                <img class="mr-1" src="/dist/img/profile/deactivated.png" alt="Deactivated">
                                {{ member.background_screening_with_out_type.background_screening_status_text || "N/A"}}
                                (Expires {{ member.background_screening_with_out_type.updated_at | formatDob }})
                            </span>
                            <span
                                class="text-warning"
                                v-else-if="member.background_screening_with_out_type != null">
                                <img class="mr-1" src="/dist/img/profile/ico-status-pending.png" alt="pending">
                                {{ member.background_screening_with_out_type.background_screening_status_text || "N/A"}}
                                <template
                                    v-if="member.background_screening_with_out_type.status === 6 &&
                                    member.background_screening_with_out_type.expiration">
                                  <br>(On {{ member.background_screening_with_out_type.expiration | formatDob }})
                                </template>
                            </span>
                            <span class="text-warning" v-else>Not Started</span>
                          </div>
                          <div class="form-group" v-else>
                            <label class="form-label">Background Screen Status</label>
                            <span>N/A</span>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group" v-if="age >= 16">
                            <label class="form-label">
                              MVR Status
                              <span
                                  v-if="member.background_screening != null && member.background_screening.background_screening_info"
                                  v-b-tooltip.hover
                                  :title="member.background_screening.background_screening_info">
                                    <img v-bind:src="'/dist/img/memberregistration/tooltip-icon-small.png'" alt="tooltipicon" />
                                </span>
                            </label>
                            <span
                                class="text-success"
                                v-if="member.background_mvr_review != null && member.background_mvr_review.status === 2">
                                <img class="mr-1" src="/dist/img/profile/ico-status-current.png" alt="Clear">
                                {{ member.background_mvr_review.background_screening_status_text || "N/A"}}
                                (Expires {{ member.background_mvr_review.expiration | formatDob }})
                            </span>
                            <span
                                class="text-danger"
                                v-else-if="(member.background_mvr_review != null &&
                                  member.background_mvr_review.status === 7) ||
                                  (member.background_mvr_review != null && member.background_mvr_review.status === 3)">
                                <img class="mr-1" style="width: 18px;" src="/dist/img/profile/deactivated.png" alt="deactivated">
                                {{ member.background_mvr_review.background_screening_status_text || "N/A"}}
                                (On {{ member.background_mvr_review.updated_at | formatDob }})
                            </span>
                            <span class="text-warning" v-else-if="member.background_mvr_review != null">
                              <img class="mr-1" src="/dist/img/profile/ico-status-pending.png" alt="pending">
                              {{ member.background_mvr_review.background_screening_status_text || "N/A"}}
                              <template v-if="member.background_mvr_review.status === 6 &&
                                member.background_mvr_review.expiration">
                                <br>(On {{ member.background_mvr_review.expiration | formatDob }})
                              </template>
                            </span>
                            <span class="text-warning" v-else>Not Started</span>
                          </div>
                          <div class="form-group" v-else>
                            <label class="form-label">MVR Status</label>
                            <span>N/A</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 l-pad">
                  <div class="card">
                    <div class="card-header">
                      <div class="header-title">
                        <h3>Address Information</h3>
                      </div>
                      <div class="modal-btn" v-if="currentMemberId === member.id">
                        <b-button v-b-modal.modal-center><span class="fa fa-edit"></span> Edit</b-button>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">Mailing Address</label>
                            <span>{{member.contact_details.address1 || "N/A"}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">Address2</label>
                            <span>{{member.contact_details.address2 || ""}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">City</label>
                            <span>{{member.contact_details.city || "N/A"}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">State</label>
                            <span v-if="member.contact_details.country === 'USA'">
                              {{member.contact_details.state_code || "N/A"}}
                            </span>
                            <span v-else>{{member.contact_details.state || "N/A"}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">Country</label>
                            <span>{{member.contact_details.country || ""}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">Postal Code</label>
                            <span>{{member.contact_details.zip || "N/A"}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4" v-if="getSiteProps('region.visible')">
                          <div class="form-group">
                            <label class="form-label">Region</label>
                            <span>{{ userProfileData.country === "USA" ? userProfileData.region : "Foreign" }}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4" v-if="enableMagazine(member)">
                          <div class="form-group">
                            <label class="form-label">Printed copy of the Water Skier magazine</label>
                            <span class="text-warning" v-if="member.printed_magazine == 1">
                              <img class="mr-1" src="/dist/img/profile/ico-status-pending.png" alt="not subscribed">
                              Not Subscribed
                            </span>
                            <span class="text-success" v-else>
                              <img class="mr-1" src="/dist/img/profile/ico-status-current.png" alt="subscribed">
                              Subscribed
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="form-check ml-4" v-if="currentMemberId === member.id">
                        <input
                            type="checkbox"
                            id="bad_address"
                            name="updateAddressInfo.bad_address"
                            class="form-check-input"
                            @click="changeBadAddress(UpdateProfile.bad_address)"
                            v-model="UpdateProfile.bad_address">
                        <label for="bad_address" class="d-flex mr-1">UnDeliverable Address</label>
                      </div>
                      <div class="ml-4" v-else-if="member.contact_details.bad_address === 1">
                        <label for="bad_address" class="d-flex mr-1 text-danger">
                          <i class="fas fa-times-circle" style="margin-top:4px"></i><b>&nbsp; UnDeliverable Address</b>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header">
                      <div class="header-title">
                        <h3>Contact Information</h3>
                      </div>
                      <div class="modal-btn" v-if="currentMemberId === member.id">
                        <b-button v-b-modal.modal-center3><span class="fa fa-edit"></span> Edit</b-button>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6 col-lg-4 ">
                          <div class="form-group">
                            <label class="form-label">{{ props_fields.contact.homephone.label || 'Home Phone'}}</label>
                            <span>{{ member.contact_details.phone_1 || "N/A" }}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">{{ props_fields.contact.mobilephone.label || 'Mobile Phone'}}</label>
                            <span>{{ member.contact_details.phone_2 || "N/A" }}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label class="form-label">Email</label>
                            <span>
                              <a class="email-link" v-bind:href="'mailto:' + member.contact_details.email">
                                {{member.contact_details.email || "N/A"}}
                              </a>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card mb-5">
                    <div class="card-header">
                      <div class="header-title">
                        <h3>{{ props_fields.demographic.title || 'Additional Information'}}</h3>
                      </div>
                      <div class="modal-btn" v-if="currentMemberId === member.id">
                        <b-button v-b-modal.edit-demographic><span class="fa fa-edit"></span> Edit</b-button>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6 col-lg-4"
                             v-if="props_fields && props_fields.demographic && props_fields.demographic.race">
                          <div class="form-group">
                            <label class="form-label">
                              {{ props_fields && props_fields.demographic ? props_fields.demographic.race.label : 'Race' }}
                            </label>
                            <span v-if="member.personal_details.diversity != null">
                              {{ member.personal_details.diversity.name }}
                            </span>
                            <span v-else>N/A</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4"
                             v-if="props_fields && props_fields.demographic && props_fields.demographic.ethnicity">
                          <div class="form-group">
                            <label class="form-label">
                              {{props_fields && props_fields.demographic ? props_fields.demographic.ethnicity.label : 'Ethnicity' }}
                            </label>
                            <span>{{member.personal_details.ethnicity || "N/A"}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4"
                             v-if="props_fields && props_fields.demographic && props_fields.demographic.veteran_status">
                          <div class="form-group">
                            <label class="form-label">
                              {{props_fields && props_fields.demographic ? props_fields.demographic.veteran_status.label : 'Veteran Status' }}
                            </label>
                            <span>{{member.personal_details.veteran_status || "N/A"}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-4"
                             v-if="props_fields && props_fields.demographic && props_fields.demographic.disability_status">
                          <div class="form-group">
                            <label class="form-label">
                              {{props_fields && props_fields.demographic ? props_fields.demographic.disability_status.label : 'Disability Status' }}
                            </label>
                            <span>{{member.personal_details.disability || "N/A"}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <FamilyMemberAddOptionPopup ref="FamilyMemberAddOptionPopup" @decideMemberType="decideMemberType" />
    <MemberLookup :familyLookup="true" @member-lookup-data="triggerMemberAddExisting" />
    <FamilyMemberAdd ref="FamilyMemberAdd" @refreshProfile="refreshProfile" />
  </div>
</template>
<script>
import axios from "axios";
import FamilyMemberAdd from "../Member/Dashboard/FamilyMemberProfileAdd";
import FamilyMemberAddOptionPopup from "./FamilyMemberAddOptionPopup";
import MemberLookup from "../club/dashboard/components/MemberLookup";

export default {
  name: 'FamilyUserProfile',
  components: {MemberLookup, FamilyMemberAddOptionPopup, FamilyMemberAdd},
  props: [
    'age',
    'props_fields',
    'userProfileData',
    'isProfileloading',
    'currentMemberId',
    'sportDisciplines',
    'startDate',
    'validThru',
    'safeSportRefreshButton'
  ],
  data: function() {
    return {
      relationArr: ["HOH", "Spouse", "Child", "Dependent"],
      UpdateProfile: {},
      addFamilyMemberLoading: false,
      refreshLoading: false
    };
  },
  methods: {
    decideMemberType(option) {
      if (option === "new") {
        this.addFamilyMember();
      } else {
        this.addExistingMember();
      }
    },
    refreshProfile() {
      this.$emit('refreshProfile');
    },
    addFamilyMember() {
      this.addFamilyMemberLoading = true;
      axios.get(this.basePath+"api/admin/member-detail/"+this.userProfileData.confirmation_code+"/admin",{ headers:this.adminHeaders })
          .then((res) => {
            this.$refs.FamilyMemberAdd.showModal(res.data.member);
          })
          .catch((error) => {
            console.log(error);
          }).finally(() => {
        this.addFamilyMemberLoading = false;
      });
    },
    resetForm() {
      this.$emit('resetForm');
    },
    switchProfileView(memberId) {
      this.$emit('switchProfileView', { id: memberId });
    },
    impersonate(confirmation_code) {
      this.$emit('impersonate', { id: confirmation_code });
    },
    enableMagazine(data) {
      return this.getSiteProps('membershipInfoEdit.printedMagazine') && ![7,13].includes(data?.membership?.id) && (data?.membership?.id !== 5 || (data?.personal_details?.relation === 0 || data?.relation === 0));
    },
    getSafeSportUserApi(member_id = null, force = false) {
      this.$emit('callSafeSportApi', { id: member_id, force: force });
    },
    detachMember(member) {
      const memberName = member?.personal_details?.full_name;
      const popupMessageNode = this.$createElement('h6', { class: 'mb-2' }, 'Are you sure you want to remove "'+memberName+'" from the family?');
      let hohPopupMessage = null;
      if (member?.personal_details?.relation === 0) {
        hohPopupMessage = this.$createElement('p', { class: 'text-danger' }, 'If a spouse exists in the family, they will be promoted as the Head of Household (HOH)');
      }
      this.$bvModal.msgBoxConfirm([popupMessageNode,hohPopupMessage], {
        noCloseOnBackdrop: true,
        noCloseOnEsc: true,
        size: "md",
        buttonSize: "sm",
        okVariant: "success",
        okTitleHtml: "<i class='fa fa-check mr-2'></i> Yes, Remove",
        cancelTitle: "No, Cancel",
        footerClass: "p-2",
        hideHeaderClose: false,
        hideHeader: true
      }).then((value) => {
        if (value === true) {
          this.refreshLoading = true;
          axios.delete(`${this.basePath}api/member/family/${member?.id}/remove`)
              .then(response => {
                const popupMessageNode = this.$createElement('h6', { class: 'mb-2 text-center' }, response?.data?.message);
                this.$bvModal.msgBoxOk([popupMessageNode]);
                if (this.currentMemberId === member?.id) {
                  this.$router.push('/admin/family-registrations/'+response?.data?.data?.refresh_id);
                }
                this.refreshProfile();
              }).catch(error => {
            console.log(error);
          }).finally(() => {
            this.refreshLoading = false;
          })
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    addExistingMember() {
      this.$bvModal.show('member-lookup-modal');
    },
    triggerMemberAddExisting(event) {
      if (event?.id) {
        this.refreshLoading = true;
        axios.post(`${this.basePath}api/member/family/add-existing`, {
          active_registration_id: this.userProfileData?.active_registration_id,
          member_id: event?.id
        })
            .then(response => {
              const popupMessageNode = this.$createElement('h6', {class: 'text-center', domProps: { innerHTML: response?.data?.message }});
              this.$bvModal.msgBoxOk([popupMessageNode]);
              this.refreshProfile();
            }).catch(error => {
          console.log("Error during existing member adding into family", error);
        }).finally(() => {
          this.refreshLoading = false;
        });
      }
    },
    changeBadAddress(val) {
      this.$emit('changeBadAddress', val);
    }
  },
  computed: {
    familyMemberCount() {
      return Object.keys(this.userProfileData?.families).length;
    }
  }
}
</script>
<style>
/* Flex layout for title with button */
.tab-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 15px;
}

.remove-btn {
  display: flex;
  align-items: center;
  padding: 5px;
}
</style>